module.exports = __webpack_public_path__ + "static/profil-306_optimized (1)-97bac8fb65a4fc0fcc3e659c5ac859ee.jpg";